let BASEURL = 'https://tradingapi.qfinity.net'
export const endPoint = {
    // Sale Order
    CREATE_SALE: `${BASEURL}/api/SaleOrder/Create`,
    UPDATE_SALE: `${BASEURL}/api/SaleOrder/Update`,
    GET_SALE: `${BASEURL}/api/SaleOrder/Get`,
    // Quotation
    CREATE_QUOT: `${BASEURL}/api/QuotationMaster/Create`,
    UPDATE_QUOT: `${BASEURL}/api/QuotationMaster/Update`,
    GET_QUOT: `${BASEURL}/api/QuotationMaster/Get`,
    // Delivery Note
    CREATE_DN: `${BASEURL}/api/DeliveryNote/Create`,
    UPDATE_DN: `${BASEURL}/api/DeliveryNote/Update`,
    GET_DN: `${BASEURL}/api/DeliveryNote/Get`,
    GET_DN_SO: `${BASEURL}/api/DeliveryNote/GetSOrderNoForDeliverNote`,
    GET_DN_SO_DETAIL: `${BASEURL}/api/DeliveryNote/GetSaleOrderDetailsForDeliveryNote`,
    GET_DN_SO_ITEM: `${BASEURL}/api/DeliveryNote/GetSOrderNoForDeliverNote`,
    //Customer 
    CREATE_CUSTOMER: `${BASEURL}/api/ECustomerMaster/Create`,
    UPDATE_CUSTOMER: `${BASEURL}/api/ECustomerMaster/Update`,
    GET_CUSTOMER: `${BASEURL}/api/ECustomerMaster/Get`,
    // Delivery Note
    CREATE_INV: `${BASEURL}/api/Invoice/Create`,
    UPDATE_INV: `${BASEURL}/api/Invoice/Update`,
    GET_INV: `${BASEURL}/api/Invoice/Get`,
    GET_SO_DRN: `${BASEURL}/api/Invoice/GetDeliveryNoteInfoOfSaleOrder`,
    GET_DRN_SO_ITEM: `${BASEURL}/api/Invoice/GetDNDetailsForInvoice`,
    GET_INV_VIEW: `${BASEURL}/api/Invoice/InvoiceView`,
    // SaleReturn

    CREATE_SALE_RETURN: `${BASEURL}/api/SaleReturn/Create`,
    UPDATE_SALE_RETURN: `${BASEURL}/api/SaleReturn/Update`,
    GET_SALE_RETURN: `${BASEURL}/api/SaleReturn/Get`,

    //Posting

    GET_SALES_POSTING: `${BASEURL}/api/SalePosting/GetBatchItems`,
    POST_SALES: `${BASEURL}/api/SalePosting/Posting`,
    GET_SALE_POST: `${BASEURL}/api/SalePosting/Get`,

    //Approval Users Category MASTER
    CREATE_APPROVAL_USER: `${BASEURL}/api/ApprovalUser/Create`,
    GET_APPROVAL_USER: `${BASEURL}/api/ApprovalUser/GetApprovalUserList`,
    GET_APPROVAL_USER_LIST: `${BASEURL}/api/ApprovalUser/GetApprovalUserForDoc`,
    UPDATE_APPROVAL_USER: `${BASEURL}/api/ApprovalUser/Update`,
    DELETE_APPROVAL_USER: `${BASEURL}/api/ApprovalUser/Delete`,
    //Approve Doc Req
    CREATE_DOC_AUTHORIZATION: `${BASEURL}/api/DocumentAuthorization/Create`,
    GET_DOC_APPROVAL_USER: `${BASEURL}/api/DocumentAuthorization/Get-Document-Approval-Users`,
    DOC_APPROVAL_EMAIL_POST: `${BASEURL}/api/DocumentAuthorization/send`,
    GET_DOC_AUTHORIZATION: `${BASEURL}/api/DocumentAuthorization/Get`,
    UPDATE_DOC_AUTHORIZATION: `${BASEURL}/api/DocumentAuthorization/Update`,
    UPDATE_DOC_AUTHORIZATION_STATUS: `${BASEURL}/api/DocumentAuthorization/UpdateDocumentStatus`,
    GET_DOC_AUTHORIZATION_STATUS: `${BASEURL}/api/DocumentAuthorization/Get`,
    DELETE_DOC_AUTHORIZATION: `${BASEURL}/api/DocumentAuthorization/Delete`,
    GET_APPROVAL_STATUS: `${BASEURL}/api/DocumentAuthorization/CheckDocumentStatus`,
    GET_DOC_STATUS_EDIT: `${BASEURL}/api/DocumentAuthorization/GetDocumentStatusForEdit`,
}